import { jsxs, jsx } from "react/jsx-runtime";
const AuroraBlob = ({ level, size }) => {
  const scale = 1 + level * 0.18;
  const layers = [
    { color: "255,80,140", delay: "0s", duration: "7s", anim: 0 },
    { color: "120,180,255", delay: "-2s", duration: "8s", anim: 1 },
    { color: "100,255,200", delay: "-4s", duration: "9s", anim: 2 },
    { color: "255,200,80", delay: "-1s", duration: "6s", anim: 3 }
  ];
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: size,
        height: size,
        position: "relative",
        borderRadius: "50%",
        overflow: "hidden",
        isolation: "isolate",
        transform: `scale(${scale})`,
        transition: "transform 100ms ease-out",
        // Deep violet core; saturated plum rim instead of near-black.
        background: "radial-gradient(circle at 50% 50%, #2a1048 0%, #1a0830 48%, #3d1868 78%, #4a2088 100%)"
      },
      "aria-hidden": true,
      children: [
        layers.map((l, i) => /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              inset: "-10%",
              background: `radial-gradient(circle at 50% 50%, rgba(${l.color},${0.82 + level * 0.14}) 0%, rgba(${l.color},0.58) 28%, rgba(${l.color},0.28) 50%, rgba(${l.color},0) 62%)`,
              mixBlendMode: "plus-lighter",
              filter: `blur(${8 + (1 - level) * 6}px)`,
              animation: `aurora-${l.anim} ${l.duration} ease-in-out ${l.delay} infinite`
            }
          },
          i
        )),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              inset: 0,
              background: "radial-gradient(circle at 35% 30%, rgba(255,255,255,0.22), transparent 38%)",
              mixBlendMode: "screen",
              pointerEvents: "none"
            }
          }
        ),
        /* @__PURE__ */ jsx("style", { children: `
        @keyframes aurora-0 {
          0%,100% { transform: translate(-22%, -18%) scale(1); }
          50%     { transform: translate(18%, 14%)  scale(1.2); }
        }
        @keyframes aurora-1 {
          0%,100% { transform: translate(20%, -16%) scale(1.15); }
          50%     { transform: translate(-18%, 18%) scale(0.95); }
        }
        @keyframes aurora-2 {
          0%,100% { transform: translate(-14%, 22%) scale(0.95); }
          50%     { transform: translate(16%, -20%) scale(1.15); }
        }
        @keyframes aurora-3 {
          0%,100% { transform: translate(16%, 18%) scale(1.05); }
          50%     { transform: translate(-20%, -14%) scale(1.25); }
        }
      ` })
      ]
    }
  );
};
export {
  AuroraBlob
};
//# sourceMappingURL=AuroraBlob.js.map
